import {h, Fragment} from "preact"


import { useFacets } from "@nosto/preact"
import { ToggleMobileSidebarButton } from "./Toolbar"
import { useEffect, useRef } from "preact/hooks"

export default function FacetTabs({ toggledFacet, setToggledFacet, numberOfProducts }) {
    const { loading, facets } = useFacets()
    const facetTabsRef = useRef(null)

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                event.preventDefault();
                const tabs = facetTabsRef.current.querySelectorAll('[role="tab"]');
                const currentIndex = Array.from(tabs).indexOf(document.activeElement);
                let nextIndex;
                
                if (event.key === 'ArrowRight') {
                    nextIndex = currentIndex + 1 >= tabs.length ? 0 : currentIndex + 1;
                } else {
                    nextIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
                }
                
                tabs[nextIndex].focus();
                tabs[nextIndex].click();
            }
        };

        if (facetTabsRef.current) {
            facetTabsRef.current.addEventListener('keydown', handleKeyDown);
            return () => {
                if (facetTabsRef.current) {
                    facetTabsRef.current.removeEventListener('keydown', handleKeyDown);
                }
            };
        }
    }, []);

    return (
        <div ref={facetTabsRef}>
            <div class="ns-d-flex ns-align-items-center" aria-label="Facet Tabs">
                {facets?.length > 0 &&
                    facets.map((facet) => (
                        <ToggleMobileSidebarButton
                            key={facet.id}
                            name={facet.name}
                            toggledFacet={toggledFacet}
                            setToggledFacet={setToggledFacet}
                            idOfFacet={facet.id}
                            className="ns-facet-tab-btn"
                            aria-selected={toggledFacet === facet.id}
                            tabIndex="0"
                            id={`tab-${facet.id}`}
                            aria-controls={`tabpanel-${facet.id}`}
                        />
                    ))}
            </div>
            <div class="ns-total-products" role="status">
                <span>{`(${numberOfProducts} products)`}</span>
            </div>
            <div>
                <ToggleMobileSidebarButton
                    name="SORT BY"
                    toggledFacet={toggledFacet}
                    setToggledFacet={setToggledFacet}
                    idOfFacet="ns-sort-tab"
                    className="ns-facet-tab-btn ns-sort-tab-btn"
                    aria-selected={toggledFacet === "ns-sort-tab"}
                    tabIndex="0"
                    id="tab-ns-sort-tab"
                    aria-controls="tabpanel-ns-sort-tab"
                />
            </div>
        </div>
    )
}


// version commented on October 2nd to adapt code for ADA compliance



// // import { useFacets } from "@nosto/preact";
// // import { ToggleMobileSidebarButton } from "./Toolbar"

// // export default function FacetTabs({ setToggledFacet, numberOfProducts }) {
// //     const { loading, facets } = useFacets()

// //     return (
// //         <>
// //             <div class="ns-d-flex ns-align-items-center">
// //                 {facets?.length > 0  && facets?.map(facet => {
// //                     return <ToggleMobileSidebarButton name={facet?.name} setToggledFacet={setToggledFacet} idOfFacet={facet?.id} className={"ns-facet-tab-btn"}/>
// //                 })}
// //                 <div class="ns-total-products">
// //                     {`(${numberOfProducts} products)`}
// //                 </div>
// //             </div>
// //             <div>
// //                 <ToggleMobileSidebarButton name={"SORT BY"} setToggledFacet={setToggledFacet} idOfFacet={"ns-sort-tab"} className={"ns-facet-tab-btn ns-sort-tab-btn"}/>
// //             </div>
// //         </>
// //     )
// // }

// import { useFacets } from "@nosto/preact"
// import { ToggleMobileSidebarButton } from "./Toolbar"
// import { useEffect, useRef } from "preact/hooks"

// export default function FacetTabs({ toggledFacet, setToggledFacet, numberOfProducts }) {
//     const { loading, facets } = useFacets()
//     const facetTabsRef = useRef(null)

//     // useEffect(() => {
//     //     const handleKeyDown = (event) => {
//     //         if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
//     //             event.preventDefault();
//     //             const items = facetTabsRef.current.querySelectorAll('.ns-facet-tab-btn');
//     //             const currentIndex = Array.from(items).indexOf(document.activeElement);
//     //             console.log(currentIndex);
//     //             let nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
//     //             nextIndex = (nextIndex + items.length) % items.length;
//     //             items[nextIndex].focus();
//     //         }
//     //     };

//     //     document.addEventListener('keydown', handleKeyDown);
//     //     return () => {
//     //         document.removeEventListener('keydown', handleKeyDown);
//     //     };
//     // }, []);

//     return (
//         <div ref={facetTabsRef}>
//             <div class="ns-d-flex ns-align-items-center" role="tablist" aria-label="Facet Tabs">
//                 {facets?.length > 0 &&
//                     facets.map((facet) => (
//                         <ToggleMobileSidebarButton
//                             key={facet.id}
//                             name={facet.name}
//                             toggledFacet={toggledFacet}
//                             setToggledFacet={setToggledFacet}
//                             idOfFacet={facet.id}
//                             className="ns-facet-tab-btn"
//                             role="tab"
//                             aria-selected={toggledFacet === facet.id}
//                             tabIndex={toggledFacet === facet.id ? 0 : -1}
//                             id={`tab-${facet.id}`}
//                             aria-controls={`tabpanel-${facet.id}`}
//                         />
//                     ))}
//             </div>
//             <div class="ns-total-products" role="status">
//                 <span>{`(${numberOfProducts} products)`}</span>
//             </div>
//             <div>
//                 <ToggleMobileSidebarButton
//                     name="SORT BY"
//                     toggledFacet={toggledFacet}
//                     setToggledFacet={setToggledFacet}
//                     idOfFacet="ns-sort-tab"
//                     className="ns-facet-tab-btn ns-sort-tab-btn"
//                     aria-selected={toggledFacet === "ns-sort-tab"}
//                     tabIndex={toggledFacet === "ns-sort-tab" ? 0 : -1}
//                     id="tab-ns-sort-tab"
//                     aria-controls="tabpanel-ns-sort-tab"
//                 />
//             </div>
//         </div>
//     )
// }
